export default function SpacingLarge({ sectionId }) {
return (
<div
id={sectionId}
style={{
height: "var(--padding-2xl)",
width: "100%"
}}
/>
);
}